import { motion } from "framer-motion";

const LOGO_SRC = "/studymate-logo.png";

/**
 * The StudyMateRanked wordmark + custom logo (provided book image).
 *
 * Note: the logo PNG already has its own built-in neon-blue glow, so this
 * component deliberately does NOT add any radial-gradient halo, drop-shadow
 * filter, or animated pulse — those layered on top made the image look
 * over-processed/blown-out. We just render it as-is and let the artwork
 * speak for itself.
 *
 * `compact` renders the inline navbar version; default renders the hero stack.
 */
export default function StudyMateLogo({ compact = false, iconOnlyMobile = false }) {
  if (compact) {
    return (
      <div className="flex items-center gap-2 sm:gap-3" data-testid="logo-compact">
        <img
          src={LOGO_SRC}
          alt="StudyMateRanked"
          className="w-7 h-7 sm:w-9 sm:h-9 object-contain"
          draggable={false}
        />
        <div className={`leading-none${iconOnlyMobile ? " hidden sm:block" : ""}`}>
          <div className="font-heading font-black text-base sm:text-lg tracking-tight">
            STUDYMATE<span className="text-blue">RANKED</span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="relative flex flex-col items-center"
      data-testid="logo-hero"
    >
      <img
        src={LOGO_SRC}
        alt="StudyMateRanked"
        className="w-[4.5rem] h-[4.5rem] sm:w-28 sm:h-28 object-contain"
        draggable={false}
      />
      <div className="mt-2 sm:mt-4 font-heading font-black text-[2rem] sm:text-5xl md:text-6xl tracking-[0.06em] sm:tracking-[0.08em] text-white text-center leading-tight">
        STUDYMATE
      </div>
      <div className="mt-1.5 sm:mt-2 flex items-center gap-2 sm:gap-3 text-blue font-mono tracking-[0.35em] sm:tracking-[0.45em] text-[10px] sm:text-xs uppercase">
        <span className="block h-px w-8 sm:w-12 bg-gradient-to-r from-transparent to-blue-400" />
        RANKED
        <span className="block h-px w-8 sm:w-12 bg-gradient-to-l from-transparent to-blue-400" />
      </div>
    </motion.div>
  );
}
